<template>
  <div>
    <md-button
      class="md-just-icon md-warning md-simple table-action pr-3"
      @click.native="triggerConfirmEdit"
    >
      <md-tooltip md-direction="top"> {{ $t("common.view") }} </md-tooltip>
      <md-icon>visibility</md-icon>
    </md-button>
    <md-button
      v-if="$can(Student.actions.deleteCommunicationLog, Student.subject)"
      class="md-just-icon md-danger md-simple table-action pl-3"
      @click.native="triggerConfirmDelete"
    >
      <md-tooltip md-direction="top"> {{ $t("common.delete") }} </md-tooltip>
      <md-icon>close</md-icon>
    </md-button>
  </div>
</template>
<script>
import { getId } from "@/helpers/utils";
import { Student } from "@/constants/Permissions";

export default {
  props: ["item"],
  inject: ["editCommunicationLog", "deleteCommunicationLog"],
  data() {
    return {
      Student
    };
  },
  methods: {
    triggerConfirmEdit() {
      this.editCommunicationLog(this.item);
    },
    triggerConfirmDelete() {
      this.deleteCommunicationLog(getId(this.item));
    }
  }
};
</script>
